import { ChainInfo } from 'api/v1/chains'
import InputAmount, { StyledInputAmountLarge } from 'components/InputAmount'
import i18n from 'i18n'
import { FC, memo } from 'react'
import { useDispatch } from 'react-redux'
import { updateAmount } from 'store/withdraw/actions'
import {
  useAmount,
  useSelectedToken,
  useWithdrawLayoutType,
} from 'store/withdraw/hook'
import { WithdrawLayoutType } from 'store/withdraw/types'
import { inputAmount } from 'utils/amount'
import { parseWeiToEther, toFixed, w2e } from 'utils/number'
import { FromTip, HeaderTipValue } from './style'
import { useWithdrawLimitByToken } from '../../hooks/zkex/useWithdrawLimitByToken'

import { StyledControlInputLarge } from '../../styles/Control'
import { Space8 } from 'styles'
import { styled } from '@mui/material'

export const Max = styled('div')`
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text100};
  padding: 0 12px;
  cursor: pointer;
  border: 1px solid rgba(46, 54, 59, 1);
  border-radius: 12px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: rgba(160, 238, 9, 1);
    border-color: rgba(160, 238, 9, 1);
  }
`
const AmountControl = styled(StyledControlInputLarge)`
  gap: 8px;
`
const Symbol = styled('span')`
  font-size: 14px;
  font-weight: 600;
`

const WithdrawAmountInput: FC<{
  l2Balance: string
  selectedNetwork?: ChainInfo
}> = memo(({ l2Balance, selectedNetwork }) => {
  const layoutType = useWithdrawLayoutType()
  const amount = useAmount()
  const dispatch = useDispatch()
  const selectedToken = useSelectedToken()
  const [limitSize] = useWithdrawLimitByToken(selectedToken?.l2CurrencyId!)

  const limit = selectedNetwork?.layerTwoChainId
    ? limitSize[selectedNetwork?.layerTwoChainId] ?? '0'
    : '0'
  return (
    <>
      <HeaderTipValue>
        <FromTip>
          {layoutType === WithdrawLayoutType.Withdraw &&
            `${i18n.t('current-withdraw-zkex-limit', {
              defaultValue: 'Current withdraw limit from ZKEX is',
            })}  ${parseWeiToEther(limit as string, 0)}`}
        </FromTip>
        <FromTip>
          Available: {toFixed(w2e(l2Balance), 2)} {selectedToken?.name}
        </FromTip>
      </HeaderTipValue>
      <Space8 />
      <AmountControl>
        <InputAmount
          as={StyledInputAmountLarge}
          value={amount}
          placeholder={`Enter amount...`}
          onInput={(a) => {
            if (a) {
              dispatch(updateAmount(inputAmount(a)))
            } else {
              dispatch(updateAmount(''))
            }
          }}
        />
        <div className="input-border" />
        <Max
          onClick={() => {
            dispatch(updateAmount(parseWeiToEther(l2Balance)))
          }}
        >
          {i18n.t('deposit-max', { defaultValue: 'MAX' })}
        </Max>
        <Symbol>{selectedToken?.name}</Symbol>
      </AmountControl>
    </>
  )
})
export default WithdrawAmountInput
